import { isRecord } from '@/shared/utils/apiResponse';

import type {
  FlowBuilderStreamEvent,
  FlowBuilderTerminalEventType,
} from '../../types/flowBuilder/flowBuilderStreamEvents';

/**
 * Confere só o envelope (`{ type: string }`), de propósito: um `type` que este cliente ainda não
 * conhece passa e cai no `default` do reducer, que o ignora. É a política aditiva do contrato — o
 * core pode emitir um evento novo antes de o front tratá-lo sem derrubar o turno.
 */
function isFlowBuilderStreamEvent(value: unknown): value is FlowBuilderStreamEvent {
  return isRecord(value) && typeof value.type === 'string';
}

export function parseFlowBuilderStreamEvent(data: string): FlowBuilderStreamEvent | null {
  try {
    const parsed: unknown = JSON.parse(data);
    return isFlowBuilderStreamEvent(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function isFlowBuilderTerminalEvent(
  event: FlowBuilderStreamEvent,
): event is Extract<FlowBuilderStreamEvent, { type: FlowBuilderTerminalEventType }> {
  return event.type === 'done' || event.type === 'error';
}
